import { type FC } from "react";

import { ActionButton, ActionButtonIntent, ActionButtonSize, Card, CardRowSimple, Dialog } from "widgets";

import { PopoverController } from "../../overlays/components/OverlayControllers.js";
import { SampleParentTile } from "../../tiles/index.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { traverseAndCollect } from "../column-props-factory.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";
import { type Parent } from "@/graphql.ts";
import { SUBROW_HEIGHT } from "@/settings/settings.js";

const SampleParentsCell: FC<IAgGridCellProps> = (props) => {
  if (props.data == null || props.value == null) {
    return null;
  }

  const { data, colDef, context } = props;
  const value = traverseAndCollect(data, colDef.groupField);
  const multiValues: Parent[] = Array.isArray(value) ? value : [value];

  if (!multiValues.length) {
    return null;
  }

  const items: ListCellItem[] = [
    {
      value: <SampleParentsPopover parents={multiValues} />,
    },
  ];
  return (
    <TableCell>
      <ListCellContent items={items} colDef={colDef} context={context} style={{ height: SUBROW_HEIGHT }} />
    </TableCell>
  );
};

const SampleParentsPopover: FC<{ parents: Parent[] }> = (props) => {
  return (
    <PopoverController
      overlayOptions={{ placement: "bottom left" }}
      actionWidget={(controllerProps) => (
        <ActionButton
          {...controllerProps}
          icon={"science"}
          size={ActionButtonSize.InTableCell}
          intent={ActionButtonIntent.Outlined}
          aria-label={"Show more details"}
        >
          {props.parents.length > 1 ? `${props.parents.length} parents` : props.parents[0].name}
        </ActionButton>
      )}
    >
      {(controllerProps) => (
        <Dialog {...controllerProps}>
          <Card scrollable={true}>
            <CardRowSimple>
              {props.parents.map((parent) => (
                <SampleParentTile parent={parent} key={parent.id} />
              ))}
            </CardRowSimple>
          </Card>
        </Dialog>
      )}
    </PopoverController>
  );
};

export default SampleParentsCell;
